<template>
  <div
    :class="[
      fixedHeight ? `h-${fixedHeight}` : 'h-fit-content',
      'flex flex-col gap-1 font-montserrat p-3 w-44 lg:w-[265px] lg:h-[90px] bg-grayscale-7 border border-grayscale-20 rounded-8 text-left cursor-pointer self-end',
    ]"
    @click="$emit('click')"
  >
    <div class="font-bold text-grayscale-96 text-sm flex gap-3">
      <p>{{ emoji }}</p>
      <p>{{ title }}</p>
    </div>
    <div class="text-grayscale-60 text-[13px]">{{ description }}</div>
  </div>
</template>
<script setup lang="ts">
const props = defineProps({
  emoji: {
    type: String,
    default: "",
  },
  title: {
    type: String,
    default: "",
  },
  description: {
    type: String,
    default: "",
  },
  // tailwind sizes, not pixels
  fixedHeight: {
    type: String,
  },
});

defineEmits(["click"]);
</script>
